import { render, staticRenderFns } from "./TypeRenderer.vue?vue&type=template&id=b1c66cd6&scoped=true&"
import script from "./TypeRenderer.vue?vue&type=script&lang=js&"
export * from "./TypeRenderer.vue?vue&type=script&lang=js&"
import style0 from "./TypeRenderer.vue?vue&type=style&index=0&id=b1c66cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c66cd6",
  null
  
)

export default component.exports